import React from 'react';

import ItemHtml from './ItemHtml';
import ItemPdf from './ItemPdf';
import ItemFichaFiscalizacao from './ItemFichaFiscalizacao';
import ItemFichaRoc from './ItemFichaRoc';
import ItemComprovanteEnvioEmail from './ItemComprovanteEnvioEmail';
import ItemFichaInfracao from './ItemFichaInfracao';
import ItemNaoSuportado from './ItemNaoSuportado';
 
export default function renderizarItem(item, infracao, hash, onReady) {
    if (item.tipoItem === "FichaInfracao")
        return <ItemFichaInfracao infracaoId={infracao.id} onReady={onReady} />;

    if (item.tipoItem === "FichaFiscalizacao")
        return <ItemFichaFiscalizacao hashFiscalizacao={infracao.hashFiscalizacao} onReady={onReady} />;

    if (item.tipoItem === "ComprovanteEnvioEmail")
        return <ItemComprovanteEnvioEmail infracao={infracao} onReady={onReady} />;

    if (item.tipoItem === "FichaProtocoloROC")
        return <ItemFichaRoc hash={hash} parametrizacaoHash={item.hash} titulo={item.identificacao} numeroInfracao={infracao.numeroInfracao} onReady={onReady} />;

    if (item.formato === "Html")
        return <ItemHtml hash={hash} parametrizacaoHash={item.hash} titulo={item.identificacao} numeroInfracao={infracao.numeroInfracao} onReady={onReady} />;

    if (item.formato === "Pdf")
        return <ItemPdf hash={hash} parametrizacaoHash={item.hash} titulo={item.identificacao} numeroInfracao={infracao.numeroInfracao} onReady={onReady} />;

    return <ItemNaoSuportado onReady={onReady} />;
}
